import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-nacionalidade-pf',
  templateUrl: './nacionalidade-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./nacionalidade-pf.component.css']
})
export class NacionalidadePfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.nacionalidade===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.nacionalidade===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
